export const LOGIN = 'LOGIN';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const ERROR_LOGIN = 'ERROR_LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_AUTH_DATA = 'SET_AUTH_DATA';

export function login(data) {
  return {
    type: LOGIN,
    payload: data,
  }
}

export function successLogin(data) {
  return {
    type: SUCCESS_LOGIN,
    payload: data,
  }
}

export function setAuth(data) {
  return {
    type: SET_AUTH_DATA,
    payload: data,
  }
}

export function errorLogin(data) {
  return {
    type: ERROR_LOGIN,
    payload: data,
  }
}

export function logout() {
  return {
    type: LOGOUT,
    payload: {},
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth/index.js